import { gql, useQuery } from "@apollo/client";
import { AddIcon, Table, Button } from "evergreen-ui";
import React from "react";
import AdminBrandArticleRow from "src/Components/AdminBrandArticleRow";
import styled from "styled-components";

const Container = styled.div`
  ${(props) => props.theme.pageContainer}
`;

const Title = styled.h1`
  ${(props) => props.theme.title}
`;

const GET_ABOUT_PAGES = gql`
  {
    about {
      id
      name
      url
      sequence
    }
  }
`;
const AdminBrandArticles = () => {
  const { data, loading, error } = useQuery(GET_ABOUT_PAGES);

  console.log(data, loading, error);

  return (
    <Container>
      <div className=" admin-page-header">
        <Title>Brand Articles ({data?.about?.length})</Title>
        <div className=" admin-buttons-group">
          <Button appearance={"minimal"} iconBefore={AddIcon}>
            New Article
          </Button>
        </div>
      </div>
      <Table>
        <Table.Head>
          <Table.TextHeaderCell>TITLE</Table.TextHeaderCell>
          <Table.TextHeaderCell>SEQUENCE</Table.TextHeaderCell>
          <Table.TextHeaderCell />
        </Table.Head>
        <Table.Body>
          {data?.about?.length > 0 ? (
            data?.about?.map((about, index) => (
              <AdminBrandArticleRow item={about} key={about.id} />
            ))
          ) : (
            <div className=" flex p-4 items-center justify-center text-center">
              No articles yet!
            </div>
          )}
        </Table.Body>
      </Table>
    </Container>
  );
};

export default AdminBrandArticles;
